import { http } from '@/app/lib/http/client'

export type PopupFrequency = 'ALWAYS' | 'ONCE' | 'EVERY_N_DAYS'
export type PopupLifecycleStatus =
  | 'active'
  | 'scheduled'
  | 'expired'
  | 'inactive'

export interface StorePopup {
  id: number
  company: number
  name: string
  image_url: string
  call_to_action_url: string | null
  sort_order: number
  is_active: boolean
  starts_at: string | null
  ends_at: string | null
  show_frequency: PopupFrequency
  show_again_after_days: number | null
  lifecycle_status: PopupLifecycleStatus
  created_at?: string
  updated_at?: string
}

export interface PopupListParams {
  search?: string
  show_frequency?: PopupFrequency
  lifecycle_status?: PopupLifecycleStatus
  page?: number
  per_page?: number
}

export interface PopupPaginator {
  current_page: number
  data: StorePopup[]
  from: number | null
  to: number | null
  last_page: number
  per_page: number
  total: number
}

export interface PopupApiError {
  message?: string
  errors?: Record<string, string[] | string | undefined>
}

const multipartHeaders = { 'Content-Type': 'multipart/form-data' }

export const popupService = {
  async getPopups(params?: PopupListParams): Promise<PopupPaginator> {
    const response = await http.get('/ecommerce/popups', { params })
    return response.data.data.popups
  },

  async getPopup(id: number): Promise<StorePopup> {
    const response = await http.get(`/ecommerce/popups/${id}`)
    return response.data.data.popup
  },

  async createPopup(data: FormData): Promise<StorePopup> {
    const response = await http.post('/ecommerce/popups', data, {
      headers: multipartHeaders,
    })
    return response.data.data.popup
  },

  async updatePopup(id: number, data: FormData): Promise<StorePopup> {
    data.append('_method', 'PUT')
    const response = await http.post(`/ecommerce/popups/${id}`, data, {
      headers: multipartHeaders,
    })
    return response.data.data.popup
  },

  async updateStatus(id: number, isActive: boolean): Promise<StorePopup> {
    const response = await http.patch(`/ecommerce/popups/${id}/status`, {
      is_active: isActive,
    })
    return response.data.data.popup
  },

  async deletePopup(id: number): Promise<void> {
    await http.delete(`/ecommerce/popups/${id}`)
  },
}
